/**
 * Egger-Bau-Wortmarke.
 *
 * Nachbau des Firmenlogos als SVG, damit es in jeder Größe scharf bleibt und
 * mitdruckt. Sobald die Originaldatei vorliegt, kann sie unter
 * web/public/logo.svg abgelegt und hier eingebunden werden.
 */
export function Logo({ height = 24 }: { height?: number }) {
  return (
    <svg
      viewBox="0 0 208 44"
      height={height}
      role="img"
      aria-label="Egger Bau"
      style={{ display: 'block' }}
    >
      {/* Bildmarke: schwarzes Quadrat mit gestaffelten Winkelformen */}
      <rect x="0" y="0" width="44" height="44" rx="1.5" fill="currentColor" />
      <path d="M10 11h17l-6.5 8.2H10z" fill="var(--surface-card)" />
      <path d="M10 22.4h13.8l-6.5 8.2H10z" fill="var(--surface-card)" />
      <path d="M27.6 22.4H34l-8.4 10.7h-6.4z" fill="var(--surface-card)" opacity="0.55" />

      {/* Trennstrich */}
      <rect x="54" y="7" width="1.6" height="30" fill="currentColor" opacity="0.28" />

      {/* Wortmarke */}
      <text
        x="66"
        y="31.5"
        fill="currentColor"
        fontFamily='"Helvetica Neue", Inter, system-ui, sans-serif'
        fontSize="25"
        fontWeight="700"
        letterSpacing="-0.6"
      >
        EGGER BAU
      </text>
    </svg>
  );
}
